import {configureStore} from "@reduxjs/toolkit";
import loginReducer from '../features/login/loginSlice'
import registerReducer from '../features/register/registerSlice'
import splashReducer from '../features/splash/splashSlice'
import homeReducer from '../features/home/homeSlice'
import movementsReducer from '../features/movements/movementsSlice'
import myMovementsReducer from '../features/my-movements/myMovementsSlice'
import step1Reducer from '../features/my-movements/create-movements/step-pages/steps-slices/step-1Slice'
import step2Reducer from '../features/my-movements/create-movements/step-pages/steps-slices/step-2Slice'
import directReducer from '../features/direct/directSlice'
import defaultPlansReducer from '../features/default-plans/defaultPlansSlice'
import showPlanReducer from '../features/default-plans/show-plan/showPlanSlice'
import exercisePlansReducer from '../features/exercise-plans/exercisePlansSlice'
import walletReducer from '../features/financial/wallet/walletSlice'

export const store = configureStore({
    reducer: {
        login: loginReducer,
        register: registerReducer,
        splash: splashReducer,
        home: homeReducer,
        movements: movementsReducer,
        myMovements: myMovementsReducer,
        step1: step1Reducer,
        step2: step2Reducer,
        direct: directReducer,
        defaultPlans: defaultPlansReducer,
        showPlan: showPlanReducer,
        exercisePlans: exercisePlansReducer,
        wallet: walletReducer,
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
})